(function(){
    'use strict';

    angular
        .module('completeAir')

        .factory('occupationCrewService', occupationCrewService);

    occupationCrewService.$inject = ['$http', 'CONFIG', 'messageService'];


    function occupationCrewService($http, CONFIG, messageService) {
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/occupationCrews';

        var service = {
            getOccupationCrews: getOccupationCrews,
            getPageOccupationCrews: getPageOccupationCrews,
            getOccupationCrewById: getOccupationCrewById,
            saveOccupationCrew: saveOccupationCrew,
            updateOccupationCrew: updateOccupationCrew,
            deleteOccupationCrew: deleteOccupationCrew
        };
        return service;

        function getOccupationCrews(){
            return $http.get(urlBase)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data._embedded) ? response.data._embedded.occupationCrews : [];
            }
            function getFailed(){
                messageService.findAllError('occupationCrews');
            }
        }

        function getPageOccupationCrews(page, size){
            return $http.get(urlBase + '/page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('occupationCrews')
                });
        }

        function saveOccupationCrew(occupationCrew){
            return $http.post(urlBase, occupationCrew)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.register('occupationCrews');
            }
            function getFailed(){
                messageService.registerError('occupationCrews');
            }
        }

        function getOccupationCrewById (id){
            return $http.get(urlBase + "/" + id)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data) ? response.data : [];
            }
            function getFailed(){
                messageService.findAllError('occupationCrews');
            }
        }

        function updateOccupationCrew(id, occupationCrew){
            return $http.put(urlBase + "/" + id, occupationCrew)
                .then(function(response){
                    messageService.registerUpdate('occupationCrews')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('occupationCrews');
                });
        }

        function deleteOccupationCrew(id) {
            return $http.delete(urlBase + "/" + id)
                .then(function(response){
                    messageService.registerDelete('occupationCrews')
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('occupationCrews','air.aircrew.occupation.associatedAircrews')
                    }else{
                        messageService.registerDeleteError('occupationCrews')
                    }
                });
        }
    }

})();

